import { useRef } from "react";
import useBoolean from "../../hooks/useBoolean";

interface CardProps {
    title: string;
    href: string;
    img: string;
}

export default function ChannelCard({ title, href, img }: CardProps) {
    const [isHidden, hide] = useBoolean();

    if (isHidden) {
        return <></>;
    }

    return (
        <li className="w-full">
            <a
                className="flex w-full flex-col gap-2 hover:underline"
                href={href}
            >
                <img
                    className="aspect-video w-full rounded-sm transition-all hover:rounded-none"
                    src={img}
                    onError={hide}
                    alt="Miniatura do Vídeo"
                />
                <h3 className="text-center text-lg font-medium">{title}</h3>
            </a>
        </li>
    );
}
